import menu from "./modules/menu";
import home from "./modules/home";
import dataCorrection from "./modules/dataCorrection"
import common from "./modules/common";
import workbench from "./modules/workbench";

export default{
    menu: menu,
    home: home,
    dataCorrection: dataCorrection, // 数据修正
    common: common, // 通用
    workbench: workbench, // 工作台
    message: { 
        username: '用户名',
        password: '密码',
        login: '登录',
        captcha: '验证码',
        forgetPassword: '忘记密码？',
        loginTip: '当前登录结果随机。验证码随便填',
        editpassword: '修改密码',
        logout: '退出登录',
        errMsg: {
            inputRequired: '请输入{cont}',
            selectRequired: '请选择{cont}'  
        }
    },
}

